<mat-form-field>
  <mat-select placeholder="Entität" #select>
    <mat-option>- Keine -</mat-option>
    <mat-option *ngFor="let patientEntity of entities" [value]="patientEntity">
      {{ patientEntity }}
    </mat-option>
  </mat-select>
</mat-form-field>
